import { yupResolver } from "@hookform/resolvers/yup";
import Button from "@src/components/Button/Button";
import EmojiPicker from "@src/components/EmojiPicker/EmojiPicker";
import FileInput from "@src/components/FileInput/FileInput";
import FormField from "@src/components/FormField/FormField";
import { api } from "@src/utils/axios-instance";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useParams } from "react-router";
import * as yup from "yup";

import "./expressionForm.style.sass";
import toast from "react-hot-toast";
import { useEffect } from "react";
import { Expression, Version } from "@src/types/global";

const schema = yup.object().shape({
    icon: yup.string().required(),
    image: yup.mixed<File | string>().required(),
    id: yup.string(),
});
interface FormValues extends yup.InferType<typeof schema> { }
interface IProps {
    defaultValues: Expression | null;
    versionId: string;
}
const ExpressionForm = ({ defaultValues, versionId }: IProps) => {
    const params = useParams();

    async function patchExpressions(data: FormValues) {
        const expForm = new FormData();
        expForm.append("image", data.image);
        expForm.append("icon", data.icon);
        if (data.id != null) {
            expForm.append("exp_id", data.id);
        }
        const res = await api.patch(
            `/characters/${params.id}/version/${versionId}/upload?type=expression`,
            expForm,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            },
        );
        return res.data;
    }

    const methods = useForm({
        //@ts-expect-error We gave yup a mixed type for images
        resolver: yupResolver(schema),
        //@ts-expect-error We gave yup a mixed type for images
        defaultValues: defaultValues,
    });
    const {
        formState: { errors },
        setValue,
        control,
        reset,
        handleSubmit,
    } = methods;
    useEffect(() => {
        //@ts-ignore Yes it is
        reset(defaultValues);
    }, [defaultValues]);

    function submit(data: FormValues) {
        mutation.mutate(data);
    }
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationKey: ["characters", params.id, "versions", versionId],
        mutationFn: patchExpressions,
        onSuccess: (data, vars) => {
            toast.success(data);
            queryClient.setQueryData(
                ["characters", params.id, "versions"],
                (prevData: Version[]) => {
                    // Get the version
                    const vIndex = prevData.findIndex((v) => v.id == versionId);
                    const version = prevData[vIndex];
                    if (version !== undefined) {
                        if (vars.id != undefined) {
                            const index = version.expressions?.findIndex(
                                (e) => {
                                    e.id == vars.id;
                                },
                            );
                            if (index != undefined) {
                                version.expressions![index] = {
                                    image: URL.createObjectURL(
                                        vars.image as File,
                                    ),
                                    icon: vars.icon,
                                    id: vars.id,
                                };
                            }
                        } else {
                            version.expressions!.push({
                                image: URL.createObjectURL(vars.image as File),
                                icon: vars.icon,
                            });
                        }
                    }
                    prevData[vIndex] = version;
                    return prevData;
                },
            );
        },
    });
    return (
        <div>
            <FormProvider {...methods}>
                {/* @ts-ignore  */}
                <form onSubmit={handleSubmit(submit)}>
                    <div className="container">
                        <div className="form__group">
                            <Controller
                                shouldUnregister={true}
                                control={control}
                                name="icon"
                                render={({ field }) => {
                                    return (
                                        <FormField
                                            errors={errors}
                                            displayName="Expression"
                                            name={`icon`}
                                        >
                                            <EmojiPicker
                                                emo={field.value}
                                                fn={(emoji) =>
                                                    setValue(`icon`, emoji)
                                                }
                                            />
                                        </FormField>
                                    );
                                }}
                            />
                            <Controller
                                shouldUnregister={true}
                                control={control}
                                name="image"
                                render={({ field }) => {
                                    return (
                                        <FormField
                                            errors={errors}
                                            displayName="Image"
                                            name={`image`}
                                            key={field.value}
                                        >
                                            <FileInput
                                                inputName={`image`}
                                                hideLabel={true}
                                                savedImagePath={field.value}
                                                parentFunction={(dataUrl) => {
                                                    setValue(`image`, dataUrl);
                                                }}
                                            />
                                        </FormField>
                                    );
                                }}
                            />
                            <Controller
                                shouldUnregister={true}
                                control={control}
                                name="id"
                                render={() => {
                                    return <input type="hidden" />;
                                }}
                            />
                        </div>
                    </div>
                    <Button
                        preset="primary"
                        type="submit"
                        isLoading={mutation.isPending}
                    >
                        Submit
                    </Button>
                </form>
            </FormProvider>
        </div>
    );
};
export default ExpressionForm;
